import Loading from './Loading';

export default Loading;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/loading/index.js
// module id = 395
// module chunks = 0